<template>
  <div class="row">
    <div class="col-12">
      <PageHeader
        :page="page"
        :has-add="false"
        :has-save="false"
        :has-submit="!readonly"
        :has-return="true"
        :has-print="readonly"
        :actions="pageActionConfig"
        @onSave="save"
        @onSubmit="onSubmit"
        @onReturn="goBack"
        @onPrint="onPrint"
      />
      <attach-discussion-document
        v-if="showAddDocument"
        title="Añadir Documento de Discusión"
        :student-sie="referralData?.studentSieId"
        :pei-at-service-id="referralData?.peiAtServiceId"
        :is-signed-pending="isDiscussedSignPendingStatus"
        @on-cancel-add-document="showAddDocument = false"
        @on-save-document="onSaveDocument($event)"
      />
      <board :details="referralInfo" class="mb-3" />
      <div class="row">
        <div class="col-12">
          <GeneralInformation
            ref="generalInformation"
            :model="model"
            :readonly="true"
            @changed="onSectionChanged"
          />

          <IssuesDiscussed
            ref="issuesDiscussed"
            :model="model"
            :readonly="readonly"
            :pei-at-information="model"
            @changed="onSectionChanged"
          />

          <Agreement
            ref="agreement"
            :model="model"
            :readonly="readonly"
            :pei-at-information="model"
            @changed="onSectionChanged"
          />
          <div v-if="isRequisitionAnalysisPendingStatus">
            <SectionTitle has-line content="Documentos" />
            <attach-discussion-document
              title="Añadir Documento de Discusión"
              :student-sie="referralData?.studentSieId"
              :pei-at-service-id="referralData?.peiAtServiceId"
              :is-signed-pending="true"
              :is-requisition-analysis-pending="
                isRequisitionAnalysisPendingStatus
              "
              :minute-file-name="model.minutaDiscussionSigned?.filename"
              @on-download-minute="
                downloadDocument(model.minutaDiscussionSigned)
              "
              @on-cancel-add-document="showAddDocument = false"
              @on-save-document="onSaveDocument($event)"
            />
          </div>

          <SectionTitle has-line content="Firma de Participantes" />
          <EvaluationDiscussionATSignatures
            ref="participantSignatures"
            :key="componentKey"
            v-model="signatureList"
            :options="availableSignatureOptions"
            :participation-types="participationTypeList"
            :alternate-participations="alternateParticipationTypeList"
            :is-draft="!readonly"
            :info-message="signatureInfoMessage"
            :fullname-only="false"
            @addSignature="addSignature()"
            @deleteSignature="deleteSignature"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EvaluationDiscussionATSignatures from './participantSignatures/EvaluationDiscussionATSignatures';
import GeneralInformation from './GeneralInformation';
import IssuesDiscussed from './IssuesDiscussed';
import Agreement from './Agreement';
import mixAlert from '@/mixin/alert.mixin';
import mixWait from '@/mixin/loading.mixin';
import store from '@/store/index';
import PageHeader from '@/components/common/page/PageHeader';
import generalService from '@/services/pei/general';
import Board from 'Board';
import AttachDiscussionDocument from './components/AttachDiscussionDocument';
import atService from '@/services/pei/at';
import objectToFormData from 'object-to-formdata';
import DocumentsService from '@/services/documents';
import { peiAtServiceStatus } from '@/utils/constants/at/peiAtServiceStatus';
import { SectionTitle } from '@/components/pei/shared';
import signatureService from '@/modules/common/signature.api';
export default {
  name: 'EvaluationDiscussion',
  mixins: [mixAlert, mixWait],
  components: {
    SectionTitle,
    GeneralInformation,
    EvaluationDiscussionATSignatures,
    IssuesDiscussed,
    Agreement,
    PageHeader,
    Board,
    AttachDiscussionDocument,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Discusión de la Evaluación',
        routes: [
          'Inicio',
          'PEI',
          'Referidos de Asistencia Tecnológica',
          'Estatus: Pendiente de Discusión',
          'Discusión de la Evaluación',
        ],
      },
      showAddDocument: false,
      readonly: false,
      errorMessage: '',
      peiAT: store.getters.SelectedAt,
      paramData: null,
      peiId: 1000000001, //Placeholder value
      model: {
        id: null,
        peiAtServiceId: null,
        othersSubject: null,
        isEvaluationAccepted: false,
        evalDiscussionDate: null,
        subjects: [],
        equipments: [],
        participants: [],
        minutaDiscussionSigned: null,
      },
      signatures: [],
      componentKey: 0,
      alternateParticipationTypeList: [],
      participationTypeList: [],
      signatureList: [],
      availableSignatureOptions: [],
      modelInfo: {
        PeiId: null,
        agencies: [],
        familyParticipationAct: '',
        familyProgressAct: '',
        revisionDate: null,
        studentRight: '',
        signatures: [],
      },
      signatureCounter: 0,
      validateComponent: false,
      signatureInfoMessage: '',
      saved: false,
      isValid: false,
      stickyButtons: {
        type: Boolean,
        Default: false,
      },
      places: [
        { signatureGroupId: 1 },
        { signatureGroupId: 5 },
        { signatureGroupId: 6 },
      ],
      sectionValid: [
        { id: 1, valid: false },
        { id: 2, valid: false },
        { id: 3, valid: false },
        { id: 4, valid: true },
      ],
      attendanceArea: 381,
      getParticipantSignatures: true,
      referralData: {},
      hasIncomplete: false,
    };
  },
  created() {
    this.loadValidationMessages();
    //   this.getInformationPeiAt();
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    referralInfoFromStorage() {
      const data = sessionStorage.getItem('ReferralData');
      const referralData = data ? JSON.parse(data) : null;

      return referralData;
    },
    showAlertMessage() {
      return (
        this.referralData.serviceStatusId ==
          peiAtServiceStatus.PendienteDeDiscusion ||
        this.referralData.serviceStatusId ==
          peiAtServiceStatus.PendienteDeDiscusionEscuela
      );
    },
    isDiscussedSignPendingStatus() {
      return (
        this.referralData.serviceStatusId ==
        peiAtServiceStatus.DiscutidoPendienteDeFirma
      );
    },
    isRequisitionAnalysisPendingStatus() {
      return (
        this.referralData.serviceStatusId ==
        peiAtServiceStatus.PendienteAnalisisRequisicion
      );
    },
    pageActionConfig() {
      return [
        {
          text: 'Anejar Documento',
          icon: 'fas fa-file-alt',
          variant: 'success',
          visible:
            this.readonly &&
            (this.referralData.serviceStatusId ==
              peiAtServiceStatus.PendienteDeDiscusion ||
              this.referralData.serviceStatusId ==
                peiAtServiceStatus.DiscutidoPendienteDeFirma) &&
            !this.showAddDocument &&
            this.model.minutaDiscussionSigned == null,
          click: () => this.onAddDocument(),
        },
        {
          text: 'Descargar Minuta de Discusión',
          icon: 'fas fas fa-file-download',
          variant: 'success',
          visible: this.readonly && this.model.minutaDiscussionSigned != null,
          click: () => this.downloadDocument(this.model.minutaDiscussionSigned),
        },
      ];
    },
    referralInfo() {
      return [
        [
          {
            label: 'Número de Referido:',
            data: this.referralData?.referralNumber,
            icon: 'fas fa-ballot-check',
          },
          {
            label: 'Estatus:',
            data: this.referralData?.serviceStatusName,
            icon: 'fas fa-ballot-check',
          },
          {
            label: 'Fecha Referido:',
            data: this.$options.filters.date(this.referralData?.referralDate),
            icon: 'fas fa-calendar-edit',
          },
          {
            label: 'CAAT:',
            data: this.referralData?.caatName,
            icon: 'fas fa-ballot-check',
          },
          {
            label: 'Estudiante/Solicitante:',
            data: `${this.referralData?.studentSieId} - ${this.referralData?.studentName}`,
            icon: 'fas fa-address-book',
          },
        ],
      ];
    },
    peiAtId() {
      const id = this.$route.params.referralId;
      const referralId = id > 0 ? parseInt(id) : null;

      return referralId;
    },
  },
  async mounted() {
    if (this.peiAtId > 0) {
      this.$store.dispatch('setSelectedAt', this.peiAtId);
      await this.getReferralSimpleData(this.peiAtId);
    }

    this.referralData = this.referralInfoFromStorage;
    await this.initData();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async initData() {
      await this.getParticipationTypeList();

      await this.getAvailableSignatureOptions();
      await signatureService
        .getAlternateParticipationTypeList()
        .then((result) => {
          this.alternateParticipationTypeList = result.data;
        });
      await this.getEvaluation();
    },
    async getReferralSimpleData(peiAtServiceId) {
      const { data } = await atService.getPeiAtServiceSimpleData(
        peiAtServiceId
      );
      if (data) {
        sessionStorage.setItem('ReferralData', JSON.stringify(data));
        this.referralData = data;
      }
    },
    loadValidationMessages() {
      const messageCodes = ['0675', '191357'];
      const promise = this.$ApiGet(
        '/api/validationsmessages?messageCodes=' +
          messageCodes.join('&messageCodes=')
      );
      promise.then((res) => {
        this.validationMessages = res.data;
      });
    },
    async getParticipationTypeList() {
      await this.$ApiGet('/api/pei/participationTypeList')
        .then((res) => {
          this.participationTypeList = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },

    async setSignatureConfig() {
      let signatureConfig = [];

      await signatureService
        .getDefaultConfiguration(null, this.referralData?.studentSieId)
        .then((result) => {
          signatureConfig = result.data;
        });
      this.signatureList = [];

      if (!this.readonly) {
        if (signatureConfig.length > 0) {
          this.signatureInfoMessage = signatureConfig.find(
            (e) => e.name != ''
          )?.name;

          signatureConfig.forEach((config) => {
            let options = {
              readonly: this.readonly,
              signatureCounter: this.signatureCounter,
              isDraft: this.readonly,
            };
            let signature = signatureService.getBasicSignature(
              this.availableSignatureOptions,
              this.model.participants,
              options,
              config.id,
              config.value
            );
            if (signature != undefined) {
              this.signatureList.push(signature);
              this.signatureCounter -= 1;
            }
          });
        } else {
          let options = {
            readonly: this.readonly,
            signatureCounter: this.signatureCounter,
            isDraft: this.readonly,
          };

          let signature1 = signatureService.getBasicSignature(
            this.availableSignatureOptions,
            this.model.participants,
            options,
            1
          );
          if (signature1 != undefined) {
            this.signatureList.push(signature1);
            this.signatureCounter -= 1;
          }
          let signature5 = signatureService.getBasicSignature(
            this.availableSignatureOptions,
            this.model.participants,
            options,
            5
          );
          if (signature5 != undefined) {
            this.signatureList.push(signature5);
            this.signatureCounter -= 1;
          }

          let signature6 = signatureService.getBasicSignature(
            this.availableSignatureOptions,
            this.model.participants,
            options,
            4
          );
          if (signature6 != undefined) {
            this.signatureList.push(signature6);
            this.signatureCounter -= 1;
          }
        }
      }
      this.loadSignatures();
    },
    loadSignatures() {
      let self = this;

      if (!Array.isArray(this.model.participants)) return;

      this.model.participants.forEach(function(data) {
        self.signatureList.push({
          id: data.id,
          signature: {
            name: data.fullName,
            positionId: { signaturePositionId: data.position.id },
            participationId: { id: Number(data.participationType) },
            alternateId: { id: data.alternateParticipationType },
          },
          groupId: 0,
          isRequired: self.ValidationTriggered.validation,

          isRemovable: !data.isEvaluationAccepted,
          isDisabled: self.readonly,
          nameDisabled: data.isEvaluationAccepted,
          participationDisabled: data.isEvaluationAccepted,
          positionDisabled: data.isEvaluationAccepted,
          isDraft: !self.readonly
        });
      });
    },
    addSignature() {
      this.signatureCounter -= 1;
      this.signatureList.push({
        id: this.signatureCounter,
        signature: {
          name: '',
          pateralName: '',
          maternalName: '',
          positionId: undefined,
          participationId: undefined,
          alternateId: undefined,
        },
        groupId: 0,
        isRequired: this.validateComponent,
        isRemovable: true,
        isDraft: !this.readonly,
        isDisabled: this.readonly,
      });
    },

    deleteSignature(id) {
      let signatureListIndex = this.signatureList.findIndex((e) => e.id === id);
      this.signatureList.splice(signatureListIndex, 1);
    },
    async getAvailableSignatureOptions() {
      await signatureService.getAvailableSignatureOptions().then((res) => {
        this.availableSignatureOptions = res.data;
      });
    },
    getMessage(code) {
      const message = this.validationMessages.find(
        (element) => element.id == code
      );
      return message;
    },
    ValidationTriggered() {
      return store.getters.getPeiValidationTriggered;
    },
    async validate() {
      let isValid = true;
      this.errorMessage = '';

      isValid &&= this.$refs.generalInformation.validate();
      isValid &&= this.$refs.issuesDiscussed.validate();
      isValid &&= this.$refs.agreement.validate();
      isValid &&= await this.$refs.participantSignatures.validate();

      return isValid;
    },
    getEvaluation() {
      this.$ApiGet(
        'api/atservice/evaldiscussionminute?peiatserviceid=' + this.peiAtId
      )
        .then((response) => {
          this.model = response.data;

          this.model.evalDiscussionDate = new Date(
            this.model.evalDiscussionDate
          );

          if (this.model.id) {
            this.signatures = this.model.participants.map((p) => ({
              name: p.name,
              positionId: p.position.id,
              alternateParticipationType: p.alternateParticipationType,
              participationType: p.participationType,
            }));

            this.componentKey = 1;
            this.readonly = true;
          }
          this.setSignatureConfig();
        })
        .catch((err) => {
          this.response = err;
        });
    },
    validateSignatures(data) {
      let isValid = true;
      let errorMsgs = 'Información incompleta. (190803)';

      if (data.participationId?.id == 2 && !data.alternateId) {
        this.ShowToast('', errorMsgs, 'error');
        isValid = false;
      }

      if (!data.name || !data.participationId?.id || !data.positionId) {
        this.ShowToast('', errorMsgs, 'error');
        isValid = false;
      }
      return isValid;
    },
    async onSubmit() {
      if (this.showAlertMessage) {
        const isConfirmed = await this.ShowCancelModal(
          'Confirmación',
          'Al someter este proceso se estará creando una copia del PEI en estatus Completado con las firmas documentadas.<br><b> ¿Está seguro que desea someter la discusión de la evaluación? </b> ',
          'Si',
          'No'
        );
        if (!isConfirmed) return;
      }

      this.validateComponent = true;

      if (!this.signatureList || this.signatureList.length === 0) {
        this.ShowToast(
          'Alerta',
          'Debe contener las firmas correspondientes',
          'error'
        );
        this.isValid = false;
        return;
      } else {
        this.signatureList.forEach((x) => (x.isRequired = this.validateComponent));
      }

      this.hasIncomplete = false;
      for (const s of this.signatureList) {
        const isSignatureValid = this.validateSignatures(s.signature);
        if (!isSignatureValid) this.hasIncomplete = true;
      }

      if (this.hasIncomplete) return;
      const isValidSections = await this.validate();
      if (!isValidSections || this.sectionValid.some(x => !x.valid)) {
        const message = this.errorMessage ? this.errorMessage : '';
        this.ShowToast('', message, 'error');
        return;
      }

      const participantsToSend = this.signatureList.map(s => ({
        id: s.id,
        name: s.signature.name,
        lastName: s.signature.paternalName,
        secondLastName: s.signature.maternalName,
        participationType: s.signature.participationId?.id,
        alternateParticipationType: s.signature.alternateId?.id ?? null,
        position: {
          id: s.signature.positionId?.signaturePositionId ?? null
        }
      }));

      const modelToSend = {
        ...this.model,
        participants: participantsToSend
      };

      await this.save(modelToSend);
      this.$router.go(0);
    },
    async save(modelToSend) {
      try {
        await this.$ApiPost('api/atservice/evaldiscussionminute', modelToSend);
        this.readonly = true;
        this.componentKey = 1;
        this.ShowToast(
          '',
          'La discusión de evaluación ha sido sometida satisfactoriamente.',
          'success'
        );
      } catch(err) {
        this.response = err;
      }
    },
    handleScroll() {
      if (window.scrollY > 200) {
        this.stickyButtons = true;
      } else {
        this.stickyButtons = false;
      }
    },
    onSectionChanged(id, isValid, message = '') {
      this.sectionValid.find((x) => x.id === id).valid = isValid;

      this.errorMessage = isValid ? this.errorMessage : message;
    },
    async onPrint() {
      const { data } = await this.$ApiGet(
        '/api/report/periatservicediscussionminute/' + this.peiAT
      );

      await generalService.documentDownloadReport(data.content, data.filename);
    },
    onAddDocument() {
      this.showAddDocument = true;
    },
    async onSaveDocument(documents) {
      let attachment = documents[0].document;
      let documentTypeId = documents[0].documentTypeId;

      let formData = objectToFormData(
        {
          peiAtServiceId: this.referralData.peiAtServiceId,
          peiAtServiceCurrentStatusId: this.referralData.serviceStatusId,
          documentTypeId: documentTypeId,
        },
        { indices: true }
      );

      formData.append('document', attachment);

      await atService
        .uploadEvaluationDocument(this.referralData.peiAtServiceId, formData)
        .then((response) => {
          this.ShowToast(
            'Proceso Exitoso.',
            'El documento ha sido anejado exitosamente.',
            'success'
          );
          this.showAddDocument = false;
          if (response.data) {
            this.referralData.serviceStatusId = response.data.serviceStatusId;
            this.referralData.serviceStatusName =
              response.data.serviceStatusName;
          }
          this.getEvaluation();
        });
    },
    downloadDocument(document) {
      DocumentsService.Download(document);
    },
  },
};
</script>

<style scoped>
.w-defined {
  display: flex;
  flex-direction: row-reverse;
}

.sticky-bottom-right {
  position: fixed;
  bottom: 50px;
  right: 50px;
  z-index: 1;
}

.section-bottom-spacing {
  margin-bottom: 50px !important;
}

.section-left-spacing {
  margin-left: 10px;
}

.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.panel-gray {
  background-color: #f8f9fa;
}

.input-group .hidden {
  display: none;
}
.input-group .entry {
  height: 25px;
  position: relative;
  width: 110px;
}
.input-group .circle {
  border: 1px solid #e2e2e2;
  border-radius: 50%;
  cursor: pointer;
  height: 20px;
  position: absolute;
  transition: border-color 300ms;
  width: 20px;
}
.input-group .entry-label {
  cursor: pointer;
  font-weight: 800;
  margin-top: -3px;
  padding-left: 30px;
  user-select: none;
  -moz-user-select: none;
}
.input-group .highlight {
  background: #2db782;
  border-radius: 50%;
  height: 10px;
  left: 5px;
  pointer-events: none;
  position: absolute;
  top: 5px;
  transition: transform 400ms cubic-bezier(0.175, 0.885, 0.32, 1.2);
  transform: translateX(0px);
  width: 10px;
}
.input-group .hidden:nth-child(1):checked ~ .highlight {
  transform: translateY(0);
}
.input-group .hidden:nth-child(3):checked ~ .highlight {
  transform: translateX(110px);
}
.input-group .hidden:nth-child(1):checked + .entry .circle {
  border-color: #e2e2e2;
}

.orange {
  color: #ff7058;
}
.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 25px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
}

/*text for navigation*/
.nav-text {
  text-align: left;
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  margin-bottom: 1rem;
}

.nav-text-link {
  color: black;
  font-weight: 400;
  text-decoration: none;
}
.nav-text-link:hover {
  color: black;
  text-decoration: none;
  font-weight: 800;
}
.nav-text-current {
  color: black;
  font-weight: 700;
  text-decoration: none;
}
.nav-text-current:hover {
  color: black;
  text-decoration: none;
  font-weight: 800;
}
.tag-badge-custom {
  background: #f5eee9;
  border-radius: 25px;
}
.double {
  transform: scale(1.3);
}
</style>
<style scoped src="@/assets/css/component/panel-simple.css"></style>
